import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const actions = {
    async createBlog(
        { commit, dispatch },
        { content, imageId, keywords, slug, summary, title, type }
    ) {
        try {
            const { data } = await Http.instance.post("/bo/blogs", {
                title,
                content,
                summary,
                slug,
                type,
                keywords,
                imageId
            });

            const blog = data;
            return blog;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BLOGS", parseError);
            throw parseError;
        }
    },

    async listBlogsPaginated(
        { commit, dispatch },
        { active, complete, itemsByPage, keyword, page }
    ) {
        try {
            const { data } = await Http.instance.get("/bo/blogs", {
                params: {
                    active,
                    complete,
                    itemsByPage,
                    keyword,
                    page
                }
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BLOGS", parseError);
            throw parseError;
        }
    },

    async getBlogBySlug({ commit, dispatch }, { slug }) {
        try {
            const { data } = await Http.instance.get(`/bo/blogs/${slug}`);
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BLOGS", parseError);
            throw parseError;
        }
    },

    async updateBlog(
        { commit, dispatch },
        { content, imageId, keywords, slug, summary, title, type }
    ) {
        try {
            const { data } = await Http.instance.patch(`/bo/blogs/${slug}`, {
                title,
                content,
                keywords,
                summary,
                type,
                imageId
            });

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BLOGS", parseError);
            throw parseError;
        }
    },
    async publishBlog({ commit, dispatch }, { active, slug, weight }) {
        try {
            const { data } = await Http.instance.put(
                `/bo/blogs/${slug}/publish`,
                {
                    active,
                    weight
                }
            );
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BLOGS", parseError);
            throw parseError;
        }
    },
    async updateBlogsFiles({ commit, dispatch }, { blogSlug, filesIds }) {
        try {
            await Http.instance.put(`/bo/blogs/${blogSlug}/files`, {
                filesIds
            });
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BLOGS", parseError);
            throw parseError;
        }
    },
    async updateBlogsProducts({ commit, dispatch }, { blogSlug, productsIds }) {
        try {
            await Http.instance.put(`/bo/blogs/${blogSlug}/products`, {
                productsIds
            });
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BLOGS", parseError);
            throw parseError;
        }
    },
    async deleteBlog({ commit, dispatch }, { slug }) {
        try {
            await Http.instance.delete(`/bo/blogs/${slug}`);
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BLOGS", parseError);
            throw parseError;
        }
    }
};

export default actions;
